import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Dropdown, Table } from 'semantic-ui-react';
import Roles from '../../constants/Roles';

import DeletePopup from '../DeletePopup';

import styles from './Item.module.scss';

const Item = React.memo(({ isAdmin, canEdit, name, username, email, role, onUpdate, onDelete }) => {
  const [t] = useTranslation();

  const handleRoleChange = useCallback(
    (e, { value }) => {
      onUpdate({
        role: value,
      });
    },
    [onUpdate],
  );

  return (
    <Table.Row>
      <Table.Cell>{name}</Table.Cell>
      <Table.Cell>{username || '-'}</Table.Cell>
      <Table.Cell>{email}</Table.Cell>
      <Table.Cell collapsing>
        <Dropdown
          disabled={!isAdmin}
          fluid
          selection
          name="newRole"
          options={Roles.map((key) => ({
            text: t(`role.${key}`),
            value: key,
          }))}
          value={role}
          placeholder={t('role.role')}
          className={styles.field}
          onChange={handleRoleChange}
        />
      </Table.Cell>
      {canEdit && (
        <Table.Cell collapsing>
          <DeletePopup
            title={t('common.deleteUser', {
              context: 'title',
            })}
            content={t('common.areYouSureYouWantToDeleteThisUser')}
            buttonContent={t('action.deleteUser')}
            onConfirm={onDelete}
          >
            <Button
              disabled={!isAdmin && role !== 'user'}
              content={t('action.delete')}
              className={styles.button}
            />
          </DeletePopup>
        </Table.Cell>
      )}
    </Table.Row>
  );
});

Item.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  username: PropTypes.string,
  email: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

Item.defaultProps = {
  username: undefined,
};

export default Item;
